import React from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const FileChip = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 10px 14px;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 6px;
`;

const FileName = styled.div`
    flex: 1;
    color: ${palette.webCyan[5]};
    font-size: 0.9rem;
    font-weight: 600;
    word-break: break-all;
`;

const RemoveButton = styled.button`
    flex-shrink: 0;
    background: #fff;
    color: #e74c3c;
    border: 1px solid #e74c3c;
    border-radius: 6px;
    padding: 5px 12px;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    transition: all 0.15s ease;

    &:hover {
        background: #e74c3c;
        color: #fff;
    }
`;

const FileInput = styled.input`
    font-size: 0.9rem;
    color: #555;
    cursor: pointer;

    &::-webkit-file-upload-button {
        font-size: 0.85rem;
        font-weight: 600;
        color: ${palette.webCyan[5]};
        background: #fff;
        border: 1px solid ${palette.webCyan[5]};
        border-radius: 6px;
        padding: 6px 14px;
        margin-right: 12px;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    &::-webkit-file-upload-button:hover {
        background: ${palette.webCyan[5]};
        color: #fff;
    }
`;

const ProgressPanel = styled.div`
    width: 100%;
    padding: 18px 20px;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 12px;
`;

const ProgressCurrentFile = styled.div`
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: 700;
    color: #2c3e50;
`;

const ProgressSummary = styled.div`
    margin-bottom: 12px;
    font-size: 0.92rem;
    color: #555;
`;

const ProgressTrack = styled.div`
    width: 100%;
    background: #e0e4ea;
    border-radius: 10px;
    height: 20px;
    margin-bottom: 14px;
    overflow: hidden;
`;

const ProgressBar = styled.div`
    background: ${palette.webCyan[5]};
    height: 100%;
    border-radius: 10px;
    transition: width 0.3s ease;
`;

const ProgressDetail = styled.div`
    font-size: 0.9rem;
    color: #868e96;

    div {
        margin-bottom: 5px;
    }
`;

const AdminClubDataInfo = ({
    selectClubInfo,
    memberFileInfo,
    setMemberFileInfo,
    membershipFileInfo,
    setMembershipFileInfo,
    lockerFileInfo,
    setLockerFileInfo,
    onSaveData,
    onTempUpdate,
    updateProgress,
}) => {

    const handleMemberFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'text/csv') {
            setMemberFileInfo(file);
        } else {
            alert('CSV 파일만 업로드 가능합니다.');
            e.target.value = '';
        }
    };

    const handleMembershipFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'text/csv') {
            setMembershipFileInfo(file);
        } else {
            alert('CSV 파일만 업로드 가능합니다.');
            e.target.value = '';
        }
    };

    const handleLockerFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'text/csv') {
            setLockerFileInfo(file);
        } else {
            alert('CSV 파일만 업로드 가능합니다.');
            e.target.value = '';
        }
    };

    const removeMemberFile = () => setMemberFileInfo(null);
    const removeMembershipFile = () => setMembershipFileInfo(null);
    const removeLockerFile = () => setLockerFileInfo(null);

    const hasAnyFile = memberFileInfo || membershipFileInfo || lockerFileInfo;

    if (!selectClubInfo) return null;

    return (
        <SettingCard title="데이터 일괄 추가">
            <SettingInfoBox>
                <SettingInfoLabel>회원 목록 파일</SettingInfoLabel>
                <SettingInfoValue>
                    {memberFileInfo ? (
                        <FileChip>
                            <FileName>
                                {memberFileInfo.name}
                            </FileName>
                            <RemoveButton
                                onClick={removeMemberFile}
                            >
                                제거
                            </RemoveButton>
                        </FileChip>
                    ) : (
                        <FileInput type="file" accept=".csv" onChange={handleMemberFileChange} />
                    )}
                </SettingInfoValue>
            </SettingInfoBox>

            <SettingInfoBox>
                <SettingInfoLabel>회원권 목록 파일</SettingInfoLabel>
                <SettingInfoValue>
                    {membershipFileInfo ? (
                        <FileChip>
                            <FileName>
                                {membershipFileInfo.name}
                            </FileName>
                            <RemoveButton
                                onClick={removeMembershipFile}
                            >
                                제거
                            </RemoveButton>
                        </FileChip>
                    ) : (
                        <FileInput type="file" accept=".csv" onChange={handleMembershipFileChange} />
                    )}
                </SettingInfoValue>
            </SettingInfoBox>

            <SettingInfoBox>
                <SettingInfoLabel>락커 목록 파일</SettingInfoLabel>
                <SettingInfoValue>
                    {lockerFileInfo ? (
                        <FileChip>
                            <FileName>
                                {lockerFileInfo.name}
                            </FileName>
                            <RemoveButton
                                onClick={removeLockerFile}
                            >
                                제거
                            </RemoveButton>
                        </FileChip>
                    ) : (
                        <FileInput type="file" accept=".csv" onChange={handleLockerFileChange} />
                    )}
                </SettingInfoValue>
            </SettingInfoBox>

            {updateProgress.isProcessing && (
                <SettingInfoBox alignTop>
                    <SettingInfoLabel>처리 진행상황</SettingInfoLabel>
                    <SettingInfoValue style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                        <ProgressPanel>
                            <ProgressCurrentFile>
                                {updateProgress.currentFile}
                            </ProgressCurrentFile>
                            <ProgressSummary>
                                전체 진행률: {updateProgress.completedCount}/{updateProgress.totalCount}
                                ({updateProgress.totalCount > 0 ? Math.round((updateProgress.completedCount / updateProgress.totalCount) * 100) : 0}%)
                            </ProgressSummary>
                            <ProgressTrack>
                                <ProgressBar
                                    style={{
                                        width: updateProgress.totalCount > 0 ? `${(updateProgress.completedCount / updateProgress.totalCount) * 100}%` : '0%',
                                    }}
                                />
                            </ProgressTrack>
                            <ProgressDetail>
                                {updateProgress.fileProgress.member.total > 0 && (
                                    <div>
                                        회원 목록: {updateProgress.fileProgress.member.completed}/{updateProgress.fileProgress.member.total}
                                    </div>
                                )}
                                {updateProgress.fileProgress.membership.total > 0 && (
                                    <div>
                                        회원권 목록: {updateProgress.fileProgress.membership.completed}/{updateProgress.fileProgress.membership.total}
                                    </div>
                                )}
                                {updateProgress.fileProgress.locker.total > 0 && (
                                    <div>
                                        락커 목록: {updateProgress.fileProgress.locker.completed}/{updateProgress.fileProgress.locker.total}
                                    </div>
                                )}
                            </ProgressDetail>
                        </ProgressPanel>
                    </SettingInfoValue>
                </SettingInfoBox>
            )}

            <CardFooter style={{gap: '12px'}}>
                <SaveButton
                    active={!updateProgress.isProcessing}
                    disabled={updateProgress.isProcessing}
                    onClick={() => onTempUpdate()}
                >
                    {updateProgress.isProcessing ? '처리 중...' : '회원권 업데이트'}
                </SaveButton>
                <SaveButton
                    active={hasAnyFile && !updateProgress.isProcessing}
                    disabled={!hasAnyFile || updateProgress.isProcessing}
                    onClick={() => onSaveData()}
                >
                    {updateProgress.isProcessing ? '처리 중...' : '일괄 추가'}
                </SaveButton>
            </CardFooter>
        </SettingCard>
    );
};

export default React.memo(AdminClubDataInfo);
